import React, { useRef, useState } from 'react';

import { makeStyles, useTheme } from '@mui/styles';

import { ButtonBase, Box, TextField } from '@mui/material';

const FileInput = ({ label, onChange, error, allowMultipleFiles }) => {
	const ref = useRef();
	const theme = useTheme();
	const classes = useStyles();
	const [fileNames, setFileNames] = useState('');

	const handleChange = (event) => {
		const files = Array.from(event.target.files);
		if (allowMultipleFiles) {
			let f = files.reduce((res, cur) => {
				return cur.name + ' ; ' + res;
			}, '');
			setFileNames(f);
			onChange(files);
		} else {
			const [file] = files;
			setFileNames(file.name);
			if (!!onChange) onChange(file);
		}
	};

	return (
		<Box
			position="relative"
			height={98}
			color={!!error ? theme.palette.error.main : theme.palette.background.paper}
			borderBottom={4}
		>
			<Box position="absolute" top={0} bottom={0} left={0} right={0} mx={2}>
				<TextField
					variant="standard"
					className={classes.field}
					InputProps={{ disableUnderline: true }}
					margin="normal"
					fullWidth
					disabled
					label={label}
					value={fileNames || ''}
					error={!!error}
					helperText={error?.message || ' '}
				/>
			</Box>
			<ButtonBase
				className={classes.button}
				component="label"
				onKeyDown={(e) => e.keyCode === 32 && ref.current?.click()}
			>
				<input
					ref={ref}
					type="file"
					accept="video/*"
					hidden
					onChange={handleChange}
					multiple={allowMultipleFiles}
				/>
			</ButtonBase>
		</Box>
	);
};

const useStyles = makeStyles((theme) => ({
	field: {
		'& .MuiFormLabel-root.Mui-disabled': {
			color: theme.palette.text.primary
		}
	},
	button: {
		width: '100%',
		height: '100%'
	}
}));

export default FileInput;
